// Accent- and case-insensitive text matching for dropdown search boxes.
export function normalizeSearch(s) {
  return String(s ?? '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
}

export function matchesSearch(term, ...fields) {
  const needle = normalizeSearch(term);
  return fields.some((field) => normalizeSearch(field).includes(needle));
}
